export enum EditMode {
  CompanyInfo = "CompanyInfo",
  DirectorInCharge = "DirectorInCharge",
  RiskMonitoringRemarks = "RiskMonitoringRemarks",
}
